"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formattedPhoneSelector = formattedPhoneSelector;
var _formatString = require("../../../../utils/formatString");
function formattedPhoneSelector(state) {
  return (0, _formatString.formatPhone)(state.authentication.twoFactor.phoneState.phone);
}